(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Grid-Cuatro-elementos"] && !Shopify.designMode) return;
  try {
    
// Animación de aparición al hacer scroll
function animateOnScroll(selector, className = 'in-view') {
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(className);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll(selector).forEach(el => observer.observe(el));
}

// Carrusel y hover de imágenes
class CustomFourItemsGrid {
  constructor(container) {
    this.container = container;
    this.items = this.container.querySelectorAll('.grid-item[data-hover-image]'); 
    this.init();
  }
  init() {
    this.items.forEach(item => {
      const img = item.querySelector('.grid-item__image');
      const primarySrc = item.dataset.primaryImage;
      const hoverSrc = item.dataset.hoverImage;
      if (!img || !primarySrc || !hoverSrc) return;
      const hoverImage = new Image();
      hoverImage.src = hoverSrc;
      item.addEventListener('mouseenter', () => { img.src = hoverSrc; });
      item.addEventListener('mouseleave', () => { img.src = primarySrc; });
    });
  }
}

// Carrusel móvil con dots y centrado
function mobileCarousel(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) return;
  const container = section.querySelector('.four-items-grid__container');
  const items = Array.from(container.querySelectorAll('.grid-item'));
  const dotsContainer = section.querySelector('.four-items-grid__dots');
  if (!container || items.length < 2) {
    if (dotsContainer) dotsContainer.style.display = 'none';
    return;
  }

  // Solo en móvil
  if (window.innerWidth > 900) {
    dotsContainer.style.display = 'none';
    return;
  }
  dotsContainer.innerHTML = '';
  dotsContainer.style.display = 'flex';

  let current = 0;
  function goTo(idx) {
    current = idx;
    const item = items[idx];
    if (!item) return;
    container.scrollTo({ left: item.offsetLeft - container.offsetLeft, behavior: 'smooth' });
    dotsContainer.querySelectorAll('.four-items-grid__dot').forEach((dot, i) => {
      dot.classList.toggle('active', i === idx);
    });
  }
  // Dots
  items.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.className = 'four-items-grid__dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Ir al elemento ' + (i + 1));
    dot.onclick = () => goTo(i);
    dotsContainer.appendChild(dot);
  });

  // Sincronizar dots con scroll
  container.addEventListener('scroll', () => {
    const scrollLeft = container.scrollLeft;
    const itemWidth = items[0].offsetWidth + 16; // 16px de gap/margin
    const idx = Math.round(scrollLeft / itemWidth);
    dotsContainer.querySelectorAll('.four-items-grid__dot').forEach((dot, i) => {
      dot.classList.toggle('active', i === idx);
    });
    current = idx;
  });

  // Swipe con touch
  let startX = 0;
  container.addEventListener('touchstart', e => { startX = e.touches[0].clientX; });
  container.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) {
      if (dx < 0 && current < items.length - 1) goTo(current + 1);
      if (dx > 0 && current > 0) goTo(current - 1);
    }
  });

  // Centrar el primer elemento al cargar
  goTo(0);
}

function initializeGrids() {
  document.querySelectorAll('[data-section-type="custom-four-items-grid"]').forEach(section => {
    if (!section.classList.contains('js-initialized')) {
      new CustomFourItemsGrid(section);
      section.classList.add('js-initialized');
    }
    // Animación de aparición para la sección y los bloques
    animateOnScroll(`#${section.id}`);
    animateOnScroll(`#${section.id} .four-items-grid__title`);
    animateOnScroll(`#${section.id} .grid-item`);
    // Carrusel móvil
    mobileCarousel(section.id);
  });
}

document.addEventListener('DOMContentLoaded', initializeGrids);
window.addEventListener('resize', () => {
  document.querySelectorAll('[data-section-type="custom-four-items-grid"]').forEach(section => {
    mobileCarousel(section.id);
  });
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-section-type="custom-four-items-grid"]')) {
      event.target.querySelectorAll('.js-initialized').forEach(el => el.classList.remove('js-initialized'));
      initializeGrids();
    }
  });
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('[data-section-type="custom-four-items-grid"]');
    if (section && !section.classList.contains('js-initialized')) {
      initializeGrids();
    }
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const section = event.target.closest('[data-section-type="custom-four-items-grid"]');
    if (section && !section.classList.contains('js-initialized')) {
      initializeGrids();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
